import { z } from 'zod'

import { WidgetTypes } from 'apps/growthTools/models/Widget/constants'

const ChannelActiveEntitySchema = z.object({
  id: z.number(),
  title: z.string(),
  widget_type: z.nativeEnum(WidgetTypes),
  flow_ns: z.string(),
})

export const ChannelApiSchemas = {
  prepareIgAccountDisable: {
    query: z.undefined(),
    path: z.undefined(),
    response: z.object({
      entities: z.array(ChannelActiveEntitySchema),
    }),
  },
  prepareFbPageDisable: {
    query: z.undefined(),
    path: z.undefined(),
    response: z.object({
      entities: z.array(ChannelActiveEntitySchema),
    }),
  },
  reconnectIgAccount: {
    query: z.undefined(),
    path: z.undefined(),
    response: z.object({
      msg: z.string(),
    }),
  },
  prepareTikTokAccountDisconnect: {
    query: z.undefined(),
    path: z.undefined(),
    response: z.object({
      subscribers_tt_active: z.number(),
      sign: z.string(),
    }),
  },
  confirmTikTokAccountDisconnect: {
    query: z.object({
      sign: z.string(),
    }),
    path: z.undefined(),
    response: z.undefined(),
  },
  confirmInstagramAccountDisconnect: {
    query: z.object({
      sign: z.string(),
    }),
    path: z.undefined(),
    response: z.undefined(),
  },
  prepareInstagramAccountDisconnect: {
    query: z.undefined(),
    path: z.undefined(),
    response: z.object({
      subscribers_ig_active: z.number(),
      sign: z.string(),
    }),
  },
  connectFBChannel: {
    query: z.undefined(),
    path: z.undefined(),
    response: z.undefined(),
    request: z.object({ return_url: z.string() }),
  },
}

export type ChannelActiveEntity = z.infer<typeof ChannelActiveEntitySchema>
